/**
 * TappingPointsPageV2 — redesigned Tapping Points list shell, port
 * of the prototype's `.screen-points` page-head
 * (cms-redesign-mockup.html ~8778–8789).
 *
 * Single coral "+ Add Point" header action. The body
 * (TappingPointsTableV2) renders the card grid.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TappingPointsTableV2 from '../../TappingPointsTable/v2/TappingPointsTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function TappingPointsPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.tapping_points.tapping_points)
      ? s.tapping_points.tapping_points.length
      : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Assets"
        title="Tapping Points"
        total={totalLabel}
        actions={
          <Link to="/tapping-points/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add Point
            </Button>
          </Link>
        }
      />
      <TappingPointsTableV2 />
    </div>
  );
}
